import styled from 'styled-components'

export const StyledGrid = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-top: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 991px) {
    padding-left: 1.5rem;
  }
`

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  text-align: center;

  @media (max-width: 576px) {
    flex-basis: 100%;
    max-width: 100%;
  }

  @media (min-width: 577px) and (max-width: 768px) {
    flex-basis: 100%;
    max-width: 100%;
  }

  @media (min-width: 769px) {
    flex-basis: 33.33333333%;
    max-width: 33.33333333%;
  }
`

export const StyledDiv = styled.div`
  @media (max-width: 768px) {
    padding-top: 2.5rem;
  }

  @media (min-width: 769px) {
    padding-top: 0.5rem;
  }
`
